export const translateCronToHumanReadable = (cronExpression: string): string => {
    const parts = cronExpression.split(' ');

    if (parts.length < 5 || parts.length > 7) {
        return "Nieprawidłowe wyrażenie CRON";
    }

    let minutes, hours, dayOfMonth, month, dayOfWeek;

    if (parts.length === 5) {
        [minutes, hours, dayOfMonth, month, dayOfWeek] = parts;
    } else if (parts.length === 6 && parts[5] === '?') {
        [minutes, hours, dayOfMonth, month, dayOfWeek] = parts.slice(0, 5);
    } else if (parts.length === 6) {
        [minutes, hours, dayOfMonth, month, dayOfWeek] = parts;
    } else {
         [minutes, hours, dayOfMonth, month, dayOfWeek] = parts.slice(1,6);
    }

    if (cronExpression === "0 0 12 * * ?" || cronExpression === "0 0 12 * *") {
        return "Codziennie o godzinie 12:00 w południe.";
    }

    let readableString = "";

    if (minutes === '0' && hours === '0') {
        readableString += "O północy";
    } else if (minutes === '*' && hours === '*') {
        readableString += "Każdej minuty";
    } else {
        readableString += "O ";
        if (hours === '*') {
            readableString += "każdej godzinie";
        } else {
            readableString += `${hours.padStart(2, '0')}`;
        }
        if (minutes === '*') {
            if (hours !== '*') readableString += ", każdej minuty";
        } else {
            readableString += `:${minutes.padStart(2, '0')}`;
        }
    }

    if (dayOfMonth === '1' && month === '*' && (dayOfWeek === '*' || dayOfWeek === '?')) {
        readableString += ", pierwszego dnia każdego miesiąca";
    } else if (dayOfMonth === '12' && month === '*' && (dayOfWeek === '*' || dayOfWeek === '?')) {
         readableString += ", dwunastego dnia każdego miesiąca";
    } else if (dayOfMonth !== '*' && dayOfMonth !== '?') {
        readableString += `, dnia ${dayOfMonth}`;
        if (month !== '*' && month !== '?') {
            const monthNames = ["", "stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca", "lipca", "sierpnia", "września", "października", "listopada", "grudnia"];
            if (month.match(/^\d+$/) && parseInt(month) >= 1 && parseInt(month) <= 12) {
                readableString += ` ${monthNames[parseInt(month)]}`;
            }
        }
    } else if (month !== '*' && month !== '?' && (dayOfMonth === '*' || dayOfMonth === '?')) {
         readableString += ` każdego miesiąca ${month}`;
    }


    if (dayOfWeek !== '*' && dayOfWeek !== '?') {
        if (readableString.includes("dnia") || readableString.includes("miesiąca") || readableString.includes("północy") || readableString.includes("godzinie")) {
             readableString += ", jeśli to ";
        } else {
            readableString += " W ";
        }
        const dayNames = ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"];
        if (dayOfWeek.match(/^\d+$/)) {
            const dayIndex = parseInt(dayOfWeek);
            if (dayIndex >= 0 && dayIndex <= 6) {
                 readableString += dayNames[dayIndex];
            } else if (dayIndex === 7) {
                 readableString += dayNames[0];
            }
        }
    }

    if (readableString === "") {
        return `Wyrażenie CRON: ${cronExpression}`;
    }

    return readableString.trim() + ".";
};
